import { animate, state, style, transition, trigger } from "@angular/animations";
import { CommonModule } from "@angular/common";
import { Component, ModuleWithProviders, NgModule } from "@angular/core";
import {
  DefaultNoComponentGlobalConfig,
  GlobalConfig,
  Toast as BaseToast,
  ToastPackage,
  ToastrService,
  TOAST_CONFIG,
} from "ngx-toastr";

// info-circle/check-success/alert-triangle-mono/alert-circle all use stroke|fill="currentColor",
// so they recolor to white on the dark toast surface. Their plain siblings (check-circle,
// alert-triangle) hardcode brand colors and would stay their original color — e.g. the warning
// icon would render orange-on-orange and disappear.
const TOAST_ICON_BY_TYPE: Record<string, string> = {
  "toast-info": "info-circle",
  "toast-success": "check-success",
  "toast-warning": "alert-triangle-mono",
  "toast-error": "alert-circle",
};

@Component({
  selector: "[toast-component2]",
  templateUrl: "./toastr.component.html",
  animations: [
    trigger("flyInOut", [
      state("inactive", style({ opacity: 0, transform: "translateY(-8px)" })),
      state("active", style({ opacity: 1, transform: "translateY(0)" })),
      state("removed", style({ opacity: 0 })),
      transition("inactive => active", animate("200ms ease-out")),
      transition("active => removed", animate("150ms ease-in")),
    ]),
  ],
  preserveWhitespaces: false,
})
export class BitwardenToast extends BaseToast {
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
  }

  get iconName(): string {
    return TOAST_ICON_BY_TYPE[this.toastPackage.toastType] ?? "info-circle";
  }

  get showAction(): boolean {
    return !!this.toastPackage.config.payload?.actionLabel;
  }

  get actionLabel(): string {
    return this.toastPackage.config.payload?.actionLabel ?? "";
  }

  onAction(): void {
    this.toastPackage.config.payload?.onAction?.();
    this.remove();
  }
}

export const BitwardenToastGlobalConfig: GlobalConfig = {
  ...DefaultNoComponentGlobalConfig,
  toastComponent: BitwardenToast,
};

@NgModule({
  imports: [CommonModule],
  declarations: [BitwardenToast],
  exports: [BitwardenToast],
})
export class BitwardenToastModule {
  static forRoot(config: Partial<GlobalConfig> = {}): ModuleWithProviders<BitwardenToastModule> {
    return {
      ngModule: BitwardenToastModule,
      providers: [
        {
          provide: TOAST_CONFIG,
          useValue: {
            default: BitwardenToastGlobalConfig,
            config: config,
          },
        },
      ],
    };
  }
}
